module.exports = __webpack_public_path__ + "img/c06_unitramship_Normal_ua.3475d098.webp";